export default {"src":"/_next/static/media/list_24.8865d197.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};